import * as z from "zod";

export const vesselConfigurationCategorySchema = z.enum([
  "vesselType",
  "propulsionDrive",
  "engineConfiguration",
  "rig",
  "additionalFeatures",
  "accommodationSpace",
]);

export type VesselConfigurationCategory = z.infer<
  typeof vesselConfigurationCategorySchema
>;

export const listVesselConfigurationOptionsInputSchema = z.object({
  organizationId: z.string(),
  category: vesselConfigurationCategorySchema,
});

export const vesselConfigurationOptionSchema = z.object({
  id: z.string(),
  label: z.string(),
});

export const listVesselConfigurationOptionsResponseSchema = z.object({
  options: z.array(vesselConfigurationOptionSchema),
});

export type ListVesselConfigurationOptionsResponse = z.infer<
  typeof listVesselConfigurationOptionsResponseSchema
>;

export const syncVesselConfigurationOptionsInputSchema = z.object({
  organizationId: z.string(),
  category: vesselConfigurationCategorySchema,
  options: z.array(z.string()),
});

export const syncVesselConfigurationOptionsResponseSchema = z.object({
  options: z.array(vesselConfigurationOptionSchema),
});

export type SyncVesselConfigurationOptionsResponse = z.infer<
  typeof syncVesselConfigurationOptionsResponseSchema
>;
